import { render, staticRenderFns } from "./GastronomyModal.vue?vue&type=template&id=cdb4df3c&scoped=true"
import script from "./GastronomyModal.vue?vue&type=script&lang=js"
export * from "./GastronomyModal.vue?vue&type=script&lang=js"
import style0 from "./GastronomyModal.vue?vue&type=style&index=0&id=cdb4df3c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cdb4df3c",
  null
  
)

export default component.exports